import React from 'react';
import QuerySuspense from '../../api/query-suspense';
import { useStoreAreaQueries } from '../../api/hooks/cash-register/store-area/use-store-area-queries';
import SplashScreen from '../../screens/splash/splash.screen';
import { StoreAreaNavigation } from '../../screens/cash-register/store-area/store-area-navigation';
import { useTenant } from '../../contexs/tenant-context';

interface CashRegisterNavigationProps {
  isOnVendorScreen: boolean;
}

export const CashRegisterNavigation = (props: CashRegisterNavigationProps) => {
  const { fetchStoreAreas } = useStoreAreaQueries();
  const { tenant } = useTenant();

  // If cash register is not enabled, don't show the navigation
  if (!tenant.plan.cash_register_enabled) {
    return null;
  }

  return (
    <QuerySuspense
      query={fetchStoreAreas}
      loadingComponent={<SplashScreen />}
      hideRefetchLoading={true}
      onSuccess={storeAreas => {
        return (
          <StoreAreaNavigation
            storeAreas={storeAreas}
            isOnline={props.isOnVendorScreen}
          />
        );
      }}
    />
  );
};

CashRegisterNavigation.defaultProps = {
  isOnVendorScreen: false,
};
